import {get, last} from 'lodash'
import {Client} from '../../../graphql/types'

/** Affiliates that historically hid RAW/VIP from the add-account list; campaign rules override when present. */
const AFFILIATE_IDS = [
  36688, 36694, 36706, 36707, 36708, 36712, 36717, 36771, 36745, 36869, 36873, 36884, 36873, 10333, 35954,
]

type VisibilityRules = {
  isMt4RawVisible?: boolean | null
  isMt4VipVisible?: boolean | null
  isMt5RawVisible?: boolean | null
  isMt5VipVisible?: boolean | null
}

function restrictedSubtypeAllowedByCampaign(
  accountSubtype: string,
  category: string,
  rules: VisibilityRules | null | undefined,
): boolean {
  const restricted = ['black', 'raw', 'mt5Raw', 'mt5Vip']
  if (!restricted.includes(accountSubtype)) return true

  if (!rules) return false

  if (category === 'forexMt4') {
    if (accountSubtype === 'raw') return rules.isMt4RawVisible !== false
    if (accountSubtype === 'black') return rules.isMt4VipVisible !== false
  }
  if (category === 'forexMt5') {
    if (accountSubtype === 'mt5Raw') return rules.isMt5RawVisible !== false
    if (accountSubtype === 'mt5Vip') return rules.isMt5VipVisible !== false
  }
  return true
}

export const overrideForAffiliates = (accounts: any[], client: Client) => {
  if (!client.affiliateId) return accounts

  if (!AFFILIATE_IDS.includes(client.affiliateId)) return accounts

  const rules = get(last(client.registrationCampaigns), 'campaign.accountTypesVisibilityRules') as
    | VisibilityRules
    | undefined

  return accounts.filter((account) =>
    restrictedSubtypeAllowedByCampaign(account.accountSubtype, account.category, rules),
  )
}
